/**
 * 虚拟仿真时钟（整数毫秒）。
 *
 * 设计文档 D6 / 风险表第 4 项：时间统一为整数毫秒，禁用系统时钟，
 * 是确定性仿真的必要条件（AC-F006-01）。
 */
export class SimClock {
  private t = 0; // 整数毫秒

  now(): number {
    return this.t;
  }

  /** 推进到指定时刻（必须为整数毫秒且不可回退）。 */
  advanceTo(time: number): void {
    if (!Number.isInteger(time)) {
      throw new Error(`SimClock.advanceTo: time must be integer ms, got ${time}`);
    }
    if (time < this.t) {
      throw new Error(`SimClock.advanceTo: cannot rewind ${this.t} -> ${time}`);
    }
    this.t = time;
  }

  reset(): void {
    this.t = 0;
  }
}
